import { RunAssembly } from "@/Components/Assemblies/RunAssembly";
import { RunnedAssembly, TabType as RunnedAssemblyTabType } from "@/Components/Assemblies/RunnedAssembly";
import { RequestFormBuilder, RequestFormBuilderProps } from "@/Components/RequestFormBuilder";
import { GetMyReportsExecutionHistoryDto } from "@/Schemas/Reports/GetMyReportsExecutionHistoryDto";
import { GetMyReportsExecutionHistoryOutput } from "@/Schemas/Reports/GetMyReportsExecutionHistoryOutput";
import { Icon, useTheme } from "@mui/material";
import { IoIosAdd, IoIosDocument } from "react-icons/io";
import { IoPlayCircle } from "react-icons/io5";
import { PopupModel, PopupProvider, UseTaskReturn, capitalizeSentences } from "vig-ui-library";

export enum PopupType {
    RUN_ASSEMBLY = "RUN_ASSEMBLY",
    RUNNED_ASSEMBLY = "RUNNED_ASSEMBLY",
    REQUEST_FORM = "REQUEST_FORM",
}

export const usePopups = () => {
    const { addPopup } = PopupProvider.usePopups();

    const theme = useTheme();

    const openRequestForm = (props: Omit<RequestFormBuilderProps, "popupId"> & { icon?: string, name?: string }) => {
        const popupId = `${PopupType.REQUEST_FORM}/${props.requestId ?? props.requestType}`;
        const popup: PopupModel = {
            id: popupId,
            name: PopupType.REQUEST_FORM,
            hideFooter: true,
            title: props.name || "Nová žiadosť",
            body: <RequestFormBuilder {...props} popupId={popupId} />,
            icon: props.icon ?
                <Icon sx={{ color: theme.palette.primary.main }}>{props.icon}</Icon> :
                <IoIosAdd size={20} color={theme.palette.primary.main} />,
            initialHeight: 875,
            initialWidth: 760,
        }
        addPopup(popup);
    }

    const openRunAssembly = (
        id: number,
        title: string,
        refreshExecutionHistoryTask: UseTaskReturn<[], GetMyReportsExecutionHistoryOutput>
    ) => {
        const popupId = `${PopupType.RUN_ASSEMBLY}/${id}`;

        const popup: PopupModel = {
            id: popupId,
            name: PopupType.RUN_ASSEMBLY,
            title: `Spustenie zostavy - ${title}`,
            body: <RunAssembly id={id} popupId={popupId} refreshExecutionHistoryTask={refreshExecutionHistoryTask} />,
            icon: <IoPlayCircle size={20} color={theme.palette.success.main} />,
            initialHeight: 720,
            hideFooter: true,
        }

        addPopup(popup);
    };

    const openRunnedAssembly = (report: GetMyReportsExecutionHistoryDto, initialTab?: RunnedAssemblyTabType) => {
        const popup: PopupModel = {
            id: `${PopupType.RUNNED_ASSEMBLY}/${report.id}`,
            name: PopupType.RUNNED_ASSEMBLY,
            title: `Spustená zostava - ${capitalizeSentences(report.report.name)}`,
            body: <RunnedAssembly report={report} initialTab={initialTab} />,
            icon: <IoIosDocument size={20} color={theme.palette.grey[600]} />,
            initialWidth: 1225,
            initialHeight: 740,
            removeFromDomOnMinimize: true,
        }

        addPopup(popup);
    }

    return {
        openRunAssembly,
        openRunnedAssembly,
        openRequestForm,
    }
}